import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import { useSelections } from "../../context/Selections";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import MonacoSVG from "../../assets/icons/monaco-svg.svg";
import InterlagosSVG from "../../assets/icons/interlagos-svg.svg";
import IndianapolisSVG from "../../assets/icons/indianapolis-svg.svg";
import MontrealSVG from "../../assets/icons/montreal-svg.svg";
import BrasilSVG from "../../assets/icons/brasil-svg.svg";
import KpiCard from "../../components/KpiCard/KpiCard";
import Modal from "../../components/Modal/Modal";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding-right: 10px;
`;

const StyledButtonReport = styled.button`
  width: 100%;
  height: 50%;
  background-color: transparent;
  border: none;
  transition: 0.3s;
  &:hover {
    background-color: #d5e3f7;
    border-radius: 8px;
    border: 5px solid #ff007f;
  }
`;

function OverviewMobile({ app, config }) {
  const [selectedValue, setSelectedValue] = React.useState("Execucao");
  const { selections } = useSelections();
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(-1);

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);
  const history = useHistory();

  const showModal = (index) => {
    history.push("/overview/pilares");
  };

  function closeModal() {
    setModalOpened(false);
  }

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Grupo Distribuição")
        : null;

      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        {/* KPIS CLC Seg.Foco */}
        {modalOpened && (
          <Modal
            title={"Pilar I - Execução CLC Seg.Foco"}
            show={modalOpened}
            setShow={() => closeModal()}
            closeButton
          >
            <Grid
              container
              direction="row"
              alignItems={"center"}
              spacing={2}
              style={{
                width: "100%",
              }}
            >
              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Total Vanish"}
                  KPITitle={"Total Vanish"}
                  percentageId={"Tqzeyj"}
                  valueId={"bcUtHJ"}
                  goalValueId={"anuRUqn"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Harpic Pastilha"}
                  KPITitle={"Harpic Pastilha"}
                  percentageId={"bCbVu"}
                  valueId={"PJEUEJ"}
                  goalValueId={"ZxhyU"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"LED Bom Ar"}
                  KPITitle={"LED Bom Ar"}
                  percentageId={"NZAgh"}
                  valueId={"GmGTDqm"}
                  goalValueId={"jaFMh"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"SBP Aero 380ml"}
                  KPITitle={"SBP Aero 380ml"}
                  percentageId={"kJaSdK"}
                  valueId={"jWPQqY"}
                  goalValueId={"jPBTdSt"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"SBP LED"}
                  KPITitle={"SBP LED"}
                  percentageId={"DkW"}
                  valueId={"CLUVKX"}
                  goalValueId={"mEzBU"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Total PIR Repelentes"}
                  KPITitle={"Total PIR Repelentes"}
                  percentageId={"zyehZjW"}
                  valueId={"YVKZbS"}
                  goalValueId={"GkjFtG"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Doypack Cozinha"}
                  KPITitle={"Doypack Cozinha"}
                  percentageId={"qYZg"}
                  valueId={"gkjJUh"}
                  goalValueId={"aCbfDE"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Doypack Banheiro"}
                  KPITitle={"Doypack Banheiro"}
                  percentageId={"HDmBUj"}
                  valueId={"TVmAd"}
                  goalValueId={"JSyrpMR"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Power Fusion Superficies"}
                  KPITitle={"Power Fusion Superficies"}
                  percentageId={"nzvbL"}
                  valueId={"JmXvg"}
                  goalValueId={"Vuykyq"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Power Fusion Pisos"}
                  KPITitle={"Power Fusion Pisos"}
                  percentageId={"JxPubS"}
                  valueId={"dXJZjc"}
                  goalValueId={"yKWhPZm"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Cuidados Íntimos"}
                  KPITitle={"Cuidados Íntimos"}
                  percentageId={"CGbdSC"}
                  valueId={"YavAP"}
                  goalValueId={"SxsVPs"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Click Spray"}
                  KPITitle={"Click Spray"}
                  percentageId={"jeJdr"}
                  valueId={"myHXrY"}
                  goalValueId={"pMXGqmF"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Nugget Líquido"}
                  KPITitle={"Nugget Líquido"}
                  percentageId={"PpxGP"}
                  valueId={"fPJTbHp"}
                  goalValueId={"kXPHp"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>

              <Grid item sx={{ flexBasis: "24%" }}>
                <KpiCard
                  app={app}
                  key={"Sustagen Kids"}
                  KPITitle={"Sustagen Kids"}
                  percentageId={"GMchUW"}
                  valueId={"utMMH"}
                  goalValueId={"hQtGWrB"}
                  hasProgressBar={true}
                  fullView
                ></KpiCard>
              </Grid>
            </Grid>
          </Modal>
        )}

        <LayoutCardsWrapper>
          <Grid container rowGap={2}>
            {/* KPIS */}
            <Grid item container>
              <LayoutCardWrapper>
                <Grid
                  container
                  direction="column"
                  gap={"10px"}
                  alignItems={"center"}
                  style={{
                    width: "90%",
                    height: "auto",
                    margin: "19px auto auto auto",
                    justifyContent: "space-between",
                    flexDirection: "row",
                  }}
                >
                  <Grid
                    item
                    width={"48.5%"}
                    className="container-card-overview"
                  >
                    <Card
                      header={{
                        hardTitle: "Monaco",
                      }}
                      style={{
                        width: "100%",
                        height: "auto",
                        position: "relative",
                      }}
                      classStyle={"row-header"}
                    >
                      <div className="container-items">
                        <NativeObject
                          className="kpiValueBold"
                          app={app}
                          key="XPQzjUb"
                          reference={{
                            id: "XPQzjUb",
                          }}
                        />

                        <div className="container-img">
                          <img src={MonacoSVG} alt="icon" />
                        </div>
                      </div>
                    </Card>
                  </Grid>

                  <Grid
                    item
                    width={"48.5%"}
                    className="container-card-overview"
                  >
                    <Card
                      header={{
                        hardTitle: "Interlagos",
                      }}
                      style={{
                        width: "100%",
                        height: "auto",
                        position: "relative",
                      }}
                      classStyle={"row-header"}
                    >
                      <div className="container-items">
                        <NativeObject
                          className="kpiValueBold"
                          app={app}
                          key="DegAcww"
                          reference={{ id: "DegAcww" }}
                        />

                        <div className="container-img">
                          <img src={InterlagosSVG} alt="icon" />
                        </div>
                      </div>
                    </Card>
                  </Grid>

                  <Grid
                    item
                    width={"48.5%"}
                    className="container-card-overview"
                  >
                    <Card
                      header={{
                        hardTitle: "Indianapolis",
                      }}
                      style={{
                        width: "100%",
                        height: "auto",
                        position: "relative",
                      }}
                      classStyle={"row-header"}
                    >
                      <div className="container-items">
                        <NativeObject
                          className="kpiValueBold"
                          app={app}
                          key="NjWPumj"
                          reference={{ id: "NjWPumj" }}
                        />

                        <div className="container-img">
                          <img src={IndianapolisSVG} alt="icon" />
                        </div>
                      </div>
                    </Card>
                  </Grid>

                  <Grid
                    item
                    width={"48.5%"}
                    className="container-card-overview"
                  >
                    <Card
                      header={{
                        hardTitle: "Montreal",
                      }}
                      style={{
                        width: "100%",
                        height: "auto",
                        position: "relative",
                      }}
                      classStyle={"row-header"}
                    >
                      <div className="container-items">
                        <NativeObject
                          className="kpiValueBold"
                          app={app}
                          key="Mrru"
                          reference={{ id: "Mrru" }}
                        />

                        <div className="container-img">
                          <img src={MontrealSVG} alt="icon" />
                        </div>
                      </div>
                    </Card>
                  </Grid>

                  <Grid
                    item
                    width={"48.5%"}
                    className="container-card-overview"
                  >
                    <Card
                      header={{
                        hardTitle: "Brasil",
                      }}
                      style={{
                        width: "100%",
                        height: "auto",
                        position: "relative",
                      }}
                      classStyle={"row-header"}
                    >
                      <div className="container-items">
                        <NativeObject
                          className="kpiValueBold"
                          app={app}
                          key="phGLbu"
                          reference={{ id: "phGLbu" }}
                        />

                        <div className="container-img">
                          <img src={BrasilSVG} alt="icon" />
                        </div>
                      </div>
                    </Card>
                  </Grid>
                </Grid>
              </LayoutCardWrapper>
            </Grid>

            {/* Ranking de Performance */}
            <LayoutCardWrapper style={{ height: "353px", marginLeft: "20px" }}>
              <Card
                app={app}
                exportTable
                // exportContainer
                exportTableId="jPZCt"
                header={{
                  hardTitle: "Ranking de Performance ",
                }}
                style={{ width: "100%" }}
                className={"container-table"}
              >
                <NativeObject
                  app={app}
                  key="jPZCt"
                  reference={{ id: "jPZCt" }}
                />
              </Card>
            </LayoutCardWrapper>

            {/* Pilares */}
            <LayoutCardWrapper
              style={{
                height: "75%",
                marginLeft: "20px",
                marginBottom: "20px",
                flexDirection: "column",
              }}
            >
              <FormControl>
                <RadioGroup
                  row
                  name="row-radio-buttons-group"
                  defaultValue="Execucao"
                  value={selectedValue}
                  onChange={handleChange}
                  className="radio-group radio-group-button-export"
                >
                  {/* Pilar I - Execução */}
                  <FormControlLabel
                    value="Execucao"
                    control={
                      <Radio
                        defaultChecked
                        size="small"
                        sx={{
                          color: "#ff007f",
                          "&.Mui-checked": {
                            color: "#ff007f",
                          },
                        }}
                      />
                    }
                    label="Pilar I - Execução"
                  />

                  {/* Pilar II - Organizacional */}
                  <FormControlLabel
                    value="Organizacional"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#ff007f",
                          "&.Mui-checked": {
                            color: "#ff007f",
                          },
                        }}
                      />
                    }
                    label="Pilar II - Organizacional"
                  />

                  {/* Pilar III - Operacional */}
                  <FormControlLabel
                    value="Operacional"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#ff007f",
                          "&.Mui-checked": {
                            color: "#ff007f",
                          },
                        }}
                      />
                    }
                    label="Pilar III - Operacional"
                  />
                </RadioGroup>
              </FormControl>

              {/* KPIs Pilares */}
              {selectedValue === "Execucao" && (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Pilar I - Execução",
                  }}
                  style={{ width: "100%", height: "100%" }}
                  className={"container-table"}
                >
                  <Grid
                    container
                    direction="column"
                    justifyContent={"center"}
                    alignItems={"center"}
                    spacing={2}
                    style={{
                      width: "100%",
                    }}
                  >
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Faturamento"}
                        KPITitle={"Faturamento"}
                        percentageId={"EpDrght"}
                        valueId={"hPhZzz"}
                        goalValueId={"YCjtVMx"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"MSL"}
                        KPITitle={"MSL"}
                        percentageId={"UytmRv"}
                        valueId={"adpW"}
                        goalValueId={"asYPTZ"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"SKU/Loja Exclusiva"}
                        KPITitle={"SKU/Loja Exclusiva"}
                        percentageId={"dHapMsB"}
                        valueId={"kPewS"}
                        goalValueId={"ZkpYpM"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"SKU/Loja Compartilhada"}
                        KPITitle={"SKU/Loja Compartilhada"}
                        percentageId={"FUyFwmJ"}
                        valueId={"VsmYQJ"}
                        goalValueId={"ZEpy"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"CLC Longo Prazo"}
                        KPITitle={"CLC Longo Prazo"}
                        percentageId={"Lqehh"}
                        valueId={"HNQKm"}
                        goalValueId={"WSKWH"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"CLC Mensal"}
                        KPITitle={"CLC Mensal"}
                        percentageId={"NtMzKZ"}
                        valueId={"SJwWHV"}
                        goalValueId={"mZAdbBZ"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"CLC Loja Única no Ano"}
                        KPITitle={"CLC Loja Única no Ano"}
                        percentageId={"jJMDTBA"}
                        valueId={"gkYKzaM"}
                        goalValueId={"mwPUT"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <StyledButtonReport onClick={() => showModal()}>
                        <KpiCard
                          app={app}
                          key={"CLC Seg.Foco"}
                          KPITitle={"CLC Seg.Foco"}
                          percentageId={"cmuG"}
                          valueId={"VCrptz"}
                          goalValueId={"JebJvm"}
                          hasProgressBar={true}
                          fullView
                        ></KpiCard>
                      </StyledButtonReport>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Mix"}
                        KPITitle={"Mix"}
                        percentageId={"aaLsAg"}
                        valueId={"jRmHYD"}
                        goalValueId={"JBHzWE"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Programa PDVPremiado"}
                        KPITitle={"Programa PDVPremiado"}
                        percentageId={"pukgKy"}
                        valueId={"CQcpxMp"}
                        goalValueId={"mwZTBhM"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Inovação"}
                        KPITitle={"Inovação"}
                        percentageId={"maEhRD"}
                        valueId={"DDexqz"}
                        goalValueId={"JnJTJBR"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Faturamento em Reppos"}
                        KPITitle={"Faturamento em Reppos"}
                        percentageId={"AMNnWnj"}
                        valueId={"WWZde"}
                        goalValueId={"kyTR"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>

                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"CLC em Reppos"}
                        KPITitle={"CLC em Reppos"}
                        percentageId={"pjDLuq"}
                        valueId={"QVDsGH"}
                        goalValueId={"XGkc"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                  </Grid>
                </Card>
              )}

              {selectedValue === "Organizacional" && (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Pilar II - Organizacional",
                  }}
                  style={{ width: "100%", height: "100%" }}
                  className={"container-table"}
                >
                  <Grid
                    container
                    direction="column"
                    justifyContent={"space-around"}
                    alignItems={"center"}
                    spacing={2}
                    style={{
                      width: "100%",
                    }}
                  >
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Pasta Exclusiva"}
                        KPITitle={"Pasta Exclusiva"}
                        percentageId={"187ee606-5011-4ec0-8277-109d14ba2793"}
                        valueId={"3ac71a2c-10ad-4ab4-ab52-b2f63c301b86"}
                        goalValueId={"ecbd6500-b210-43db-88a5-6fbd5c573dfa"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Pasta Compartilhada"}
                        KPITitle={"Pasta Compartilhada"}
                        percentageId={"9181af90-d4a1-4ded-bd68-51b1024b6e90"}
                        valueId={"7d77471d-46cc-4fae-a89c-3db122dfebe0"}
                        goalValueId={"88aa717c-3d9d-49ce-b41c-67af887da6da"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Pasta Compartilhada Fornecedor"}
                        KPITitle={"Pasta Compartilhada Fornecedor"}
                        percentageId={"8c39046f-e117-432b-b321-5e6d0127e2b4"}
                        valueId={"b0a028d9-be54-430e-be27-4bc5c3cc5a1e"}
                        goalValueId={"70a8c885-9cec-4d21-9cf4-2bfa5d8dc179"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Area de Atuação"}
                        KPITitle={"Area de Atuação"}
                        percentageId={"da27766d-d3ef-4239-a1ac-977e1b86768a"}
                        valueId={"910c5c81-cf75-4e5f-9d52-a22f63d73b4a"}
                        goalValueId={"e0d43b79-64b3-4a52-9efa-103ed04b270d"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"JBP"}
                        KPITitle={"JBP"}
                        percentageId={"f2a51260-ac63-4918-afae-9d57e84b577e"}
                        valueId={"0548d1c8-cd4d-459d-8426-d318496db8b7"}
                        goalValueId={"924200c1-8d10-4f65-9825-409e8f184298"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Gerente Geral"}
                        KPITitle={"Gerente Geral"}
                        percentageId={"2ab092ae-8234-42a6-8219-2ee6b900955f"}
                        valueId={"761971db-fda1-4938-b6d6-46d1c50d1014"}
                        goalValueId={"5ca258d0-b2e7-4fc3-9d54-a17a7eec0f16"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Analista"}
                        KPITitle={"Analista"}
                        percentageId={"5433c628-20b3-4f09-a9d4-c50be91d7c45"}
                        valueId={"af05e851-4794-47ec-859e-86eae665df7e"}
                        goalValueId={"49c94444-e132-4f93-a64d-396784108b2b"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Força de Vendas"}
                        KPITitle={"Força de Vendas"}
                        percentageId={"6fc2e521-702e-4cc3-860f-d50ac5910e5c"}
                        valueId={"e985226c-9115-435b-bf82-5ee20bf52d6f"}
                        goalValueId={"46cf291a-f530-4bc3-a371-7150c78874e5"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Remuneração Variável"}
                        KPITitle={"Remuneração Variável"}
                        percentageId={"d9ec8c8d-6166-4265-96de-6b1d375f0329"}
                        valueId={"5dcec89d-07a2-4290-aa2a-45c77c09115c"}
                        goalValueId={"f103c5c7-d285-4808-ac40-06ab379d6daa"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Treinamentos"}
                        KPITitle={"Treinamentos"}
                        percentageId={"5cbcb184-b917-44a4-9209-88e2a7209166"}
                        valueId={"267e2b17-9184-499f-be21-6acec77cb6b7"}
                        goalValueId={"a61e90c7-fc61-473b-b817-a7114251c83b"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Política de Crédito"}
                        KPITitle={"Política de Crédito"}
                        percentageId={"5ce2714c-eefb-4138-9ea1-717435355cd8"}
                        valueId={"cc1809de-ef00-4637-8bcc-3eefb2edbe26"}
                        goalValueId={"2c4325bc-4a1e-4f99-bd1e-7784655939f6"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Finanças"}
                        KPITitle={"Finanças"}
                        percentageId={"cbca5463-9361-431d-adf5-83e02d5e4a9c"}
                        valueId={"0e5e094c-105b-498e-8af5-f6cc6e11f5ff"}
                        goalValueId={"9eba60cc-fd49-4e34-8246-809a1ecda6fa"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                  </Grid>
                </Card>
              )}
              {selectedValue === "Operacional" && (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Pilar III - Operacional",
                  }}
                  style={{ width: "100%", height: "100%" }}
                  className={"container-table"}
                >
                  <Grid
                    container
                    direction="row"
                    justifyContent={"space-around"}
                    alignItems={"center"}
                    spacing={2}
                    style={{
                      width: "100%",
                    }}
                  >
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Executivo Reppos"}
                        KPITitle={"Executivo Reppos"}
                        percentageId={"8c8e6290-2ccc-485a-b876-8df1e73026b8"}
                        valueId={"9a0045ce-25da-47be-8948-9833af543a1e"}
                        goalValueId={"251c55ec-582c-4abc-a879-00f7d07202c5"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Promotores"}
                        KPITitle={"Promotores"}
                        percentageId={"8ca886ec-4042-4017-9dea-fe9806a83104"}
                        valueId={"9ff79c8d-32af-4422-b820-a1b1588a93ff"}
                        goalValueId={"d09fb7cf-08ce-49d8-884c-f9902bf1818a"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Rota de Vendas"}
                        KPITitle={"Rota de Vendas"}
                        percentageId={"68cdaac5-8448-4822-832c-6527764ba080"}
                        valueId={"6e5a6e83-8676-44da-809f-0181868509a8"}
                        goalValueId={"ca597cd3-cf63-4b11-8d52-a7d14a8d6388"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Dados"}
                        KPITitle={"Dados"}
                        percentageId={"420fa201-022f-4ccc-915a-2df59e69b328"}
                        valueId={"4b1de3df-c5c3-434b-9898-94b03129f635"}
                        goalValueId={"cac14ca7-f054-4d7d-b8fa-0eba8eb83a95"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Ferramentas Digitais"}
                        KPITitle={"Ferramentas Digitais"}
                        percentageId={"966f0cd9-4637-4767-9ce3-980a5c4cea76"}
                        valueId={"32083e72-ec75-40c4-84a2-ae24e0449cf9"}
                        goalValueId={"84da4e80-0f2d-4ec8-934b-07bb4ec66488"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"Faseamento de Pedidos"}
                        KPITitle={"Faseamento de Pedidos"}
                        percentageId={"e27a0ada-e590-4e74-be4b-f95c2368734b"}
                        valueId={"49875759-707b-484b-b7fe-406444c7150d"}
                        goalValueId={"221df2ef-8c93-46b9-b86d-c0c729201fdb"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                    <Grid item>
                      <KpiCard
                        app={app}
                        key={"MOQ"}
                        KPITitle={"MOQ"}
                        percentageId={"aa80bd31-cd78-4e6e-9764-19e656ab28a2"}
                        valueId={"d7c23ab5-8ee5-4d54-a51e-5fae7ab71042"}
                        goalValueId={"75079b4f-9f20-4dd5-a954-a4073360aded"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>
                    </Grid>
                  </Grid>
                </Card>
              )}
            </LayoutCardWrapper>
          </Grid>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

OverviewMobile.defaultProps = {
  app: null,
  config: {},
};

OverviewMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewMobile;
